import axios from "../utils/axios";

function request(functionId, body) {
  let data = {
    functionId,
    body
  };
  return axios.request({
    data: data,
    method: "post"
  });
}

// 处理举报
export function submitPenaltyInfo(body) {
    return request("jdh_submitPenaltyInfo", body);
}

// 举报列表
export function queryUserReports(body) {
    return request("jdh_queryUserReports", body);
}

// 处罚列表
export function queryUserPenalties(body) {
    return request("jdh_queryUserPenalties", body);
}